import { getLanguageTranslation, fetchExistedLanguages } from '../../services/language'
import { fetchClientSettings } from '../../services/client'
import { setLanguage } from '../../i18n-setup'

const state = {
    selectedLanguage: null,
    availableLanguages: {},
    translation: {},
    clientSettings: {},
    isTable: false,
    tableNumber: null,
    isReady: false,
}

const getters = {}

const actions = {
    setSelectedLanguage({ commit, dispatch }, value) {
        commit('SET_SELECTED_LANGUAGE', value)
        dispatch('getLanguageTranslation', value.key)
    },

    async getAvailableLanguages({ commit }) {
        const languages = await fetchExistedLanguages();
        commit('SET_AVAILABLE_LANGUAGES', languages);
    },

    async getLanguageTranslation({ commit }, key) {
        const translation = await getLanguageTranslation(key);
        setLanguage(key, translation)
        commit('SET_SELECTED_LANGUAGE_TRANSLATION', translation);
    },

    async fetchClientSettings({ commit }) {
        const settings = await fetchClientSettings();
        commit('SET_CLIENT_SETTINGS', settings.data)
    },

    setIsTable({ commit }, value) {
        commit('SET_IS_TABLE', value)
    },

    setTableNumber({ commit }, value) {
        commit('SET_TABLE_NUMBER', value)
    },

    setIsReady({ commit }, value) {
        commit('SET_IS_READY_APP', value)
    }
}

const mutations = {
    SET_SELECTED_LANGUAGE: (state, value) => {
        state.selectedLanguage = value;
    }, 
    SET_SELECTED_LANGUAGE_TRANSLATION: (state, value) => {
        state.translation = value;
    },
    SET_AVAILABLE_LANGUAGES: (state, value) => {
        state.availableLanguages = value;
    },
    SET_CLIENT_SETTINGS: (state, value) => {
        state.clientSettings = value;
    },
    SET_IS_TABLE: (state, value) => {
        state.isTable = value
    },
    SET_TABLE_NUMBER: (state, value) => {
        state.tableNumber = value
    },
    SET_IS_READY_APP: (state, value) => {
        state.isReady = value
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }
  